import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-down-left",
  templateUrl: "./med-icon-arrow-down-left.component.html",
})
export class MedIconArrowDownLeftComponent extends SvgMixinComponent {}
